import { routes } from '@routes';

type TParams = {
  authPath: string;
  invitationId: string;
  email: string | null;
};

export const getInvitationAuthPath = ({ authPath, invitationId, email }: TParams): string => {
  const searchParams = new URLSearchParams({ goto: routes.acceptInvitation.make(invitationId) });
  const trimmedEmail = email?.trim();

  if (trimmedEmail) {
    searchParams.set('email', trimmedEmail);
  }

  return `${authPath}?${searchParams.toString()}`;
};
